/**
 * Le icone dei test di misura, uguali in elenco, dettaglio ed esecuzione: una
 * per metodo di calcolo, e una per il test le cui misure usano più metodi.
 */

import {
  AlarmClockPlusIcon,
  ChartNoAxesColumnIncreasingIcon,
  CrosshairIcon,
  LayersIcon,
  type LucideIcon,
  PercentIcon,
  TrendingDownIcon,
  TrendingUpIcon,
} from 'lucide-react';
import { ETICHETTA_METODO_TEST, type MetodoTest } from '@calcio/shared';

const ICONA_METODO_TEST: Record<MetodoTest, LucideIcon> = {
  percentuale: PercentIcon,
  diretta: TrendingUpIcon,
  inversa: TrendingDownIcon,
  target: CrosshairIcon,
  gradini: ChartNoAxesColumnIncreasingIcon,
  penalita: AlarmClockPlusIcon,
};

/** L'icona del metodo, con il nome come etichetta e suggerimento. */
export function IconaMetodo({ metodo, className }: { metodo: MetodoTest; className?: string }) {
  const Icona = ICONA_METODO_TEST[metodo];
  const nome = ETICHETTA_METODO_TEST[metodo];
  return (
    <Icona role="img" aria-label={nome} className={className}>
      <title>{nome}</title>
    </Icona>
  );
}

/** L'icona del test: quella del metodo, o una sola per più metodi, con i loro nomi. */
export function IconaMetodi({ metodi, className }: { metodi: MetodoTest[]; className?: string }) {
  if (metodi.length === 1) return <IconaMetodo metodo={metodi[0]!} className={className} />;
  const nome = `Più metodi: ${metodi.map((m) => ETICHETTA_METODO_TEST[m]).join(', ')}`;
  return (
    <LayersIcon role="img" aria-label={nome} className={className}>
      <title>{nome}</title>
    </LayersIcon>
  );
}
